










































import { Component, Vue } from 'vue-property-decorator'
import GlobalMixins from '../mixins'
import { bus, zirafHTTP, setAuthHeader } from '../main'
import BigText from '@/components/BigText.vue'

@Component({
	components: {
		BigText
	}
})
export default class Login extends GlobalMixins {
    email: string = ''
    password: string = ''
    emailError: boolean = false
    passwordError: boolean = false

    forgottenPassword(): void {
        alert('Neem contact op met Internetbureau Slik om je wachtwoord te resetten')
    }
    login(): void {
        this.formError = false
        this.emailError = false
        this.passwordError = false

        if (!this.email || !this.password) return
        if (!this.validateEmail(this.email)) {
            this.formError = this.returnErrorByCode(30002)
            this.emailError = true

            return
        }

        zirafHTTP.post('auth/login', {
            username: this.email,
            password: this.password
        })
            .then((response: any) => {
				window.localStorage.setItem('accessToken', response.data.accessToken)
				
				setAuthHeader()

				Vue.nextTick(() => {
					this.$router.push({ name: 'users' })
				})
            })
            .catch((error: any) => {
				console.error(error.response.data)

				window.localStorage.removeItem('accessToken')

                if (error.response.data.errorCode === 30000 || error.response.data.errorCode === 10103) {
                    this.emailError = true
                    this.passwordError = true
                } if (error.response.data.errorCode === 30001 || error.response.data.errorCode === 30002) {
                    this.emailError = true
                }   if (error.response.data.errorCode === 30003) {
                    this.passwordError = true
                }

                this.formError = this.returnErrorByCode(error.response.data.errorCode)
            })
    }

    mounted() {
        bus.$on('displayError', (error: string) => {
            this.formError = error
		})

		if (this.$store.getters.loginError) {
			this.formError = this.$store.getters.loginError

			this.$store.dispatch('setLoginError', false)
		}
		if (this.$store.getters.loginMessage) {
			this.formMessage = this.$store.getters.loginMessage

			this.$store.dispatch('setLoginMessage', false)
		}

		if (window.localStorage.getItem('accessToken')) {
			zirafHTTP.get('auth/check-token')
				.then(response => {
					this.$router.push({ name: 'users' })
				})
				.catch(error => {
					this.formError = this.returnErrorByCode(error.response.data.errorCode)

					window.localStorage.removeItem('accessToken')
					
					bus.$emit('initComplete')
				})
		} else {
			bus.$emit('initComplete')
		}
    }
}
